import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from 'react';
export function ScrollDownFab({ scrollContainerRef }) {
    const [visible, setVisible] = useState(false);
    const checkScroll = useCallback(() => {
        const el = scrollContainerRef.current;
        if (!el)
            return;
        const { scrollTop, scrollHeight, clientHeight } = el;
        setVisible(scrollHeight - scrollTop - clientHeight > 100);
    }, [scrollContainerRef]);
    useEffect(() => {
        const el = scrollContainerRef.current;
        if (!el)
            return;
        checkScroll();
        el.addEventListener('scroll', checkScroll, { passive: true });
        // ResizeObserver: catches container resize (window resize etc.)
        const ro = new ResizeObserver(checkScroll);
        ro.observe(el);
        // MutationObserver: catches child content changes (tab switch, data load)
        const mo = new MutationObserver(checkScroll);
        mo.observe(el, { childList: true, subtree: true });
        return () => {
            el.removeEventListener('scroll', checkScroll);
            ro.disconnect();
            mo.disconnect();
        };
    }, [checkScroll, scrollContainerRef]);
    const handleClick = () => {
        const el = scrollContainerRef.current;
        if (!el)
            return;
        el.scrollBy({ top: el.clientHeight, behavior: 'smooth' });
    };
    if (!visible)
        return null;
    return (_jsx("button", { type: "button", className: "miniapp-scroll-down-fab", onClick: handleClick, "aria-label": "Scroll down", children: _jsx("i", { className: "fas fa-chevron-down" }) }));
}
